export default __webpack_public_path__ + "static/media/@jaqueraimundo.9b90226b.jpg";